import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Glasses, Search, ShieldCheck, ArrowRight } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

export default function DatiOttici() {
  const [clienti, setClienti] = useState([]);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/clienti", { params: q ? { q } : {} }).then((r) => setClienti(r.data));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-slate-900">Dati Ottici</h1>
        <p className="text-sm text-slate-500 mt-1">Prescrizioni OD/OS e storico controlli, archiviati separatamente dall'anagrafica.</p>
      </div>

      <div className="rounded-xl border border-[#1E40AF]/20 bg-[#1E40AF]/5 p-4 flex items-start gap-3">
        <ShieldCheck className="h-5 w-5 text-[#1E40AF] mt-0.5" />
        <div className="text-sm text-slate-700">
          <span className="font-semibold">Privacy by Design.</span> I parametri ottici (sfera, cilindro, asse) sono dati sanitari e non vengono mai utilizzati dai segmenti o dalle campagne marketing.
        </div>
      </div>

      <div className="relative max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input data-testid="ottica-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca cliente per aprire i dati ottici…" className="pl-9 h-10 bg-white" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {clienti.map((c) => (
          <button
            key={c.id}
            data-testid={`ottica-card-${c.id}`}
            onClick={() => navigate(`/clienti/${c.id}`)}
            className="text-left p-5 rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-md hover:border-[#1E40AF]/40 transition-all group"
          >
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-lg bg-[#0F172A] text-white flex items-center justify-center"><Glasses className="h-5 w-5" /></div>
              <ArrowRight className="h-4 w-4 text-slate-300 group-hover:text-[#1E40AF] transition-colors" />
            </div>
            <div className="mt-3 font-head font-semibold text-slate-900">{c.cognome} {c.nome}</div>
            <div className="text-xs text-slate-500 mt-1">Ultimo controllo: {c.data_ultimo_controllo || "—"}</div>
            <div className="mt-2">
              {c.segmenti?.includes("richiamo_36") ? <Badge className="bg-red-100 text-red-700 hover:bg-red-100">Richiamo 36 mesi</Badge>
                : c.segmenti?.includes("richiamo_24") ? <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100">Richiamo 24 mesi</Badge>
                : <Badge variant="secondary">Aggiornato</Badge>}
            </div>
          </button>
        ))}
        {clienti.length === 0 && <div className="col-span-full text-center text-slate-500 py-12">Nessun cliente trovato.</div>}
      </div>
    </div>
  );
}
